import { useState, useEffect } from "react";
import { MessageCircle, Menu, X } from "lucide-react";
import { LOGO_URL, waLink } from "@/data/siteData";

const LINKS = [
  { name: "Packages", href: "#packages", testid: "nav-packages-link" },
  { name: "Why Us", href: "#why-choose", testid: "nav-why-link" },
  { name: "Experiences", href: "#experiences", testid: "nav-experiences-link" },
  { name: "Plan My Trip", href: "#enquiry", testid: "nav-enquiry-link" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-40 transition-[background-color,border-color] duration-500 border-b ${
        scrolled ? "glass-header border-gold/20" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 sm:h-[70px] flex items-center justify-between">
        <a href="#hero" data-testid="nav-logo-link" className="flex items-center gap-3 group">
          <img
            src={LOGO_URL}
            alt="RAJ TRAVELS GOA logo"
            className="w-10 h-10 sm:w-11 sm:h-11 rounded-full ring-2 ring-gold/60 object-cover transition-transform duration-500 group-hover:rotate-6"
          />
          <div className="leading-tight">
            <span className="font-cinzel font-bold tracking-[0.14em] text-sm sm:text-base text-ivory block">
              RAJ TRAVELS
            </span>
            <span className="font-cinzel text-[10px] sm:text-xs tracking-[0.42em] gold-text block">GOA</span>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={l.testid}
              className="text-sm text-slate-300 hover:text-gold transition-colors duration-300 tracking-wide"
            >
              {l.name}
            </a>
          ))}
          <a
            href={waLink("Hi RAJ TRAVELS GOA, I need a quick Goa holiday quote.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-cta-btn"
            className="inline-flex items-center gap-2 bg-gold text-navy-abyss text-sm font-semibold px-5 py-2.5 rounded-full hover:bg-gold-hover transition-colors duration-300"
          >
            <MessageCircle className="w-4 h-4" />
            WhatsApp Us
          </a>
        </nav>

        <button
          data-testid="nav-mobile-menu-btn"
          aria-label="Open menu"
          onClick={() => setOpen(!open)}
          className="md:hidden text-ivory p-2"
        >
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden glass-header border-t border-gold/15 px-6 py-5 flex flex-col gap-4" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`mobile-${l.testid}`}
              onClick={() => setOpen(false)}
              className="text-base text-slate-200 py-1"
            >
              {l.name}
            </a>
          ))}
          <a
            href={waLink("Hi RAJ TRAVELS GOA, I need a quick Goa holiday quote.")}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="mobile-nav-whatsapp-cta-btn"
            className="inline-flex items-center justify-center gap-2 bg-gold text-navy-abyss font-semibold px-5 py-3 rounded-full"
          >
            <MessageCircle className="w-4 h-4" />
            WhatsApp Us
          </a>
        </div>
      )}
    </header>
  );
}
